import { render, staticRenderFns } from "./TiktokOrderList.vue?vue&type=template&id=4b5e3319&scoped=true"
import script from "./TiktokOrderList.vue?vue&type=script&lang=js"
export * from "./TiktokOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e3319",
  null
  
)

export default component.exports